import React,{useContext} from 'react';
import { AppBar, Toolbar, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';

const Navbar = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  

  const logoutUser = () => {
    // Clear the token from context (or local storage, wherever it's stored)
   

    // Redirect to login (or another appropriate route)
    navigate('/login');
  };
  
  return (
    <AppBar position="static" style={{ background: theme.palette.primary.main }}>
      <Toolbar>
        <Typography variant="h6" style={{ flexGrow: 1, color: theme.palette.text.primary }}>
          Bizzence
        </Typography>
        <Button style={{ color: theme.palette.text.primary }} onClick={logoutUser}>
          Logout
        </Button>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
